import React from "react";
import SingleJobPopup from "./SingleJobPopup";

const MultiJobPopup = ({
  jobConfig = [],
  templateObject = {},
  allJobs,
  smId,
  device,
  onChange,
  // label = "",
  type = "statemachine"
}) => {
  const newJobCongi = {
    job_id: "",
    params: {},
    job_template: ""
  };

  const deleteJobFromJobConfig = (index) => {
    const newJobConfig = [...jobConfig];
    newJobConfig.splice(index, 1);
    onChange(newJobConfig);
  };
  const updateJobConfig = (data, index) => {
    if (!data.job_id) {
      deleteJobFromJobConfig(index);
      return;
    }
    const newJobConfig = [...jobConfig];
    let updateIndex = index;
    // if (index !== jobConfig.length) {
    //   updateIndex = index;
    // }
    newJobConfig[updateIndex] = data;
    onChange(newJobConfig);

    return;
  };

  return (
    <div className="flex_column gap_1">
      {[...jobConfig, newJobCongi].map((job, index) => (
        <SingleJobPopup
          key={job.job_id}
          config={{
            job_id: job.job_id || "",
            params: job.params || {},
            job_template: job.job_template || ""
          }}
          onChange={(data) => updateJobConfig(data, index)}
          allJobs={allJobs}
          smId={smId}
          device={device}
          type={type}
          templateObject={templateObject}
        />
      ))}
    </div>
  );
};

export default MultiJobPopup;
